var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3,16.6c0,0.2,0,0.3,0,0.5c0,1.3,0,2.6,0,3.9c0,1.1-0.7,1.7-1.7,1.6c-0.3,0-0.6-0.2-0.9-0.4C7.3,19.1,4,16.2,0.6,13.2 c-0.8-0.7-0.8-1.7,0-2.5C4,7.8,7.4,4.9,10.7,1.9c0.5-0.4,1.1-0.6,1.7-0.3c0.6,0.3,0.9,0.8,0.9,1.5c0,1.3,0,2.6,0,3.9 c0,0.1,0,0.3,0,0.4c0.2,0,0.3,0,0.5,0c2.8,0,5.6,0,8.5,0c1.1,0,1.7,0.6,1.7,1.7c0,1.9,0,3.9,0,5.8c0,1-0.6,1.7-1.7,1.7 c-2.8,0-5.7,0-8.5,0C13.7,16.6,13.5,16.6,13.3,16.6z M11.8,21c0-0.2,0-0.3,0-0.4c0-1.5,0-3,0-4.5c0-0.8,0.4-1,1-1c3,0,6.1,0,9.1,0 c0.1,0,0.3,0,0.5,0c0-2,0-4,0-6.1c-0.2,0-0.3,0-0.5,0c-3.1,0-6.1,0-9.2,0c-0.7,0-0.9-0.3-0.9-0.9c0-1.5,0-2.9,0-4.4 c0-0.2,0-0.3,0-0.6C8.3,6.1,5,9,1.5,12C5,15,8.4,18,11.8,21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.55a66952b9794679492a543a00c4bd08.svg";
export { ForwardRef as ReactComponent };